// 单词本API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 单词本API接口类
 */
export class WordBookAPI {
  /**
   * 获取单词列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.size - 每页大小
   * @param {string} params.keyword - 搜索关键词
   * @param {string} params.category - 分类
   * @param {string} params.difficulty - 难度
   * @param {string} params.status - 状态
   * @returns {Promise} API响应
   */
  static async getWordList(params = {}) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.WORD_BOOK.LIST, params);
      return {
        success: true,
        data: response.data || response,
        message: "获取单词列表成功",
      };
    } catch (error) {
      console.error("获取单词列表失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取单词列表失败",
      };
    }
  }

  /**
   * 获取单词分类
   * @returns {Promise} API响应
   */
  static async getCategories() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.WORD_BOOK.CATEGORIES);
      return {
        success: true,
        data: response.data || response,
        message: "获取分类成功",
      };
    } catch (error) {
      console.error("获取分类失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取分类失败",
      };
    }
  }

  /**
   * 获取单词统计
   * @returns {Promise} API响应
   */
  static async getStatistics() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.WORD_BOOK.STATISTICS);
      return {
        success: true,
        data: response.data || response,
        message: "获取统计成功",
      };
    } catch (error) {
      console.error("获取统计失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取统计失败",
      };
    }
  }
}

export default WordBookAPI;
